import Intercom from 'common/utils/Intercom';

export default () => {
   if(localStorage.getItem('superAdminSession')) {
      return;
   }
   Intercom.init();
};
